<template>
    <div>
        <!-- evidencia tipo link -->
        <link-prevue :url="evidencia.url" v-if="evidencia.url">
            <template slot-scope="props">
                <v-card>
                    <v-card-title class="text-xs-center mb-4">
                        <v-layout row >
                            <v-flex xs5>
                                <h2 class="headline" style="text-align: left">{{evidencia.title}}</h2>

                            </v-flex>
                            <v-flex xs7>
                                <v-layout row style="text-align: right" align-content-end
                                 justify-end>
                                    <v-spacer></v-spacer>

                                <v-layout align-end column class='mr-2'>
                                    <v-flex>  
                                    <h4>
                                        {{evidencia.author}}
                                    </h4>
                                    </v-flex>
                                    <v-flex>
                                    {{ evidencia.modified | moment('LL') }}
                                    </v-flex>
                                </v-layout>
                                    <div v-if="evidencia.status === 'S'" style="height: 55px; width: 55px; background: #90e1f0 ; border-radius: 30px ">
                                        <v-avatar class="ma-1">
                                            <img :src="image" alt="" style="margin-right: 2px" >
                                        </v-avatar>
                                        <div class="badge1">
                                            <v-icon class="mr-3" v-if="evidencia.status === 'A' || evidencia.status === 'F'">school</v-icon>
                                            <v-icon class="" v-if="evidencia.status === 'P' || evidencia.status === 'F'">public</v-icon>
                                        </div>
                                    </div>
                                <div >
                                <v-menu  bottom left v-if="permissao && moreopts">
                                    <v-btn icon slot="activator" class="mx-0">
                                    <v-icon class="mx-0">more_vert</v-icon>
                                    </v-btn>
                                    <v-list>
                                    <v-list-tile @click="publicar(evidencia)">
                                        <v-list-tile-title>Publicar</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="$emit('avaliar')">
                                        <v-list-tile-title>Avaliar</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile @click="dialog = true">
                                        <v-list-tile-title>Deletar</v-list-tile-title>
                                    </v-list-tile>
                                    </v-list>
                                </v-menu>
                                </div>

                                </v-layout>
                            </v-flex>
                        </v-layout> 
                    </v-card-title>
                    <v-card-media contain :src="props.img" height="300px">
                    </v-card-media>
                    <v-card-text v-if="evidencia.audio">
                        <aplayer :music="{src: evidencia.audio,
                        name: evidencia.title,
                        artist: ''}" preload="none" />
                    </v-card-text>
                    <v-card-text v-if="evidencia.description">
                        <p>
                        {{props.title}}
                        </p>
                        <p>
                        {{props.description}}
                        </p>
                        <v-chip
                        v-for="tag in evidencia.tags"
                        :key="tag"
                        label
                        color="blue"
                        outline> {{ tag }}</v-chip>

                    </v-card-text>
                    <v-card-actions>
                        <v-btn flat color="blue" :href="props.url">
                        Ver link
                        </v-btn>
                        <v-spacer></v-spacer>
                        <div v-if="permissao">
                            <v-btn flat color="blue" v-if="avaliavel" @click="$emit('avaliar')">
                                <span v-if="evidencia.status === 'A' || evidencia.status === 'F'"> Avaliado </span>
                                <span v-else>Avaliar</span>
                            </v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
                <v-dialog v-model="dialog" persistent max-width="290">
                    <v-card>
                        <v-card-title class="headline">Deseja deletar?</v-card-title>
                        <v-card-text>Gostaria excluir a evidência?</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" flat @click.native="dialog = false">Cancelar</v-btn>
                            <v-btn color="green darken-1" flat @click.native="excluir(evidencia)">Deletar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

            </template>    
        </link-prevue>
        
        <!-- evidencias de outros tipos -->
        <v-card v-else>
            <v-card-title class="text-xs-center mb-4">
                <v-layout row >
                    <v-flex xs5>
                        <h2 class="headline" style="text-align: left">{{evidencia.title}}</h2>

                    </v-flex>
                    <v-flex xs7>
                        <v-layout row style="text-align: right" align-content-end justify-end>
                            <v-spacer></v-spacer>

                        <v-layout align-end column class='mr-2'>
                            <v-flex>  
                            <h4>
                                {{evidencia.author}}
                            </h4>
                            </v-flex>
                            <v-flex>
                            {{ evidencia.modified | moment('LL') }}
                            </v-flex>
                        </v-layout>
                        <div v-if="evidencia.auto_avaliado" style="height: 55px; width: 55px; background: #90e1f0 ; border-radius: 30px ">
                            <v-avatar class="ma-1">
                                <img :src="image" alt="" style="margin-right: 2px" >
                            </v-avatar>
                            <div class="badge1">
                                <v-icon class="mr-3" v-if="evidencia.status === 'A' || evidencia.status === 'F'">school</v-icon>
                                <v-icon class="" v-if="evidencia.status === 'P' || evidencia.status === 'F'">public</v-icon>
                            </div>
                        </div>
                        <div v-else >
                            <v-avatar >
                                <img :src="image" alt="" >
                            </v-avatar>
                            <div class="badge1">
                                <v-icon class="mr-3" v-if="evidencia.status === 'A' || evidencia.status === 'F'">school</v-icon>
                                <v-icon class="" v-if="evidencia.status === 'P' || evidencia.status === 'F'">public</v-icon>
                            </div>
                        </div>
                        <v-menu  bottom left 
                            v-if="permissao && moreopts">
                            <v-btn icon slot="activator" class="mx-0">
                            <v-icon class="mx-0">more_vert</v-icon>
                            </v-btn>
                            <v-list>
                            <v-list-tile @click="publicar(evidencia)">
                                <v-list-tile-title>Publicar</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="$emit('avaliar')">
                                <v-list-tile-title>Avaliar</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="dialog = true">
                                <v-list-tile-title>Deletar</v-list-tile-title>
                            </v-list-tile>
                            </v-list>
                        </v-menu>
                         <v-dialog v-model="dialog" persistent max-width="290">
                          <v-card>
                            <v-card-title class="headline">Deseja deletar?</v-card-title>
                            <v-card-text>Gostaria excluir a evidência?</v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="red darken-1" flat @click.native="dialog = false">Cancelar</v-btn>
                              <v-btn color="green darken-1" flat @click.native="excluir(evidencia)">Deletar</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-snackbar
                        v-model="snackbar"
                        bottom
                        color="success">
                        {{ text }}
                          <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
                        </v-snackbar>

                        </v-layout>
                    </v-flex>
                </v-layout> 
            </v-card-title>
            <v-card-media v-if="evidencia.video" height="300px">

            <video controls width="100%">
            <source :src="evidencia.video" type="video/mp4">
            </video>

            <!-- <video-player class="vjs-custom-skin"
                    ref="videoPlayer"
                    :options="{
                    fluid: true,
                    autoplay: false,
                    preload: false,
                    sources: [{
                        type: 'video/mp4',
                        src: evidencia.video
                    }]
                    }"
                    :playsinline="true" >
                </video-player>  -->

            </v-card-media>
            <v-card-media v-if="evidencia.image && evidencia.video === null" :src="evidencia.image" :srcset="evidencia.image" height="300px" @click="imagexp=true">
              <v-dialog
              max-width="520px"
              v-model="imagexp">
                <v-card>
                  <v-card-actions class="justify-center row">
                   <img :src="evidencia.image" ref="foto"  style="max-height: 100%" width="500px" >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-media>
            <v-card-media v-if="evidencia.reg_file" style="text-align: center;" height="300px">
                <a :href="evidencia.reg_file" style="text-align: center;" class="mx-auto mt-5 pt-3" >
                <v-icon  style="font-size: 150px;"
                centered>description</v-icon>
                </a>
            </v-card-media>
            <v-card-media v-if="evidencia.audio">
                 <audio controls class="mt-3" style="display: block; width:100%;">
                    <source :src="evidencia.audio" >
                </audio> 
                <!-- <aplayer :music="{src: evidencia.audio,
                name: evidencia.title,
                artist: ''}" preload="none" /> -->
            </v-card-media>
            <v-card-text v-if="evidencia.description">
              <p>
               {{evidencia.description}}
              </p>

              <v-chip
              v-for="tag in evidencia.tags"
              :key="tag"
              label
              color="blue"
              outline> {{ tag }}</v-chip>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div 
                v-if="permissao">
                    <v-btn flat color="blue" v-if="avaliavel" @click="$emit('avaliar')">
                        <span v-if="evidencia.status === 'A' || 
                        evidencia.status === 'F'"> Avaliado </span>
                        <span v-else>Avaliar</span>
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import LinkPrevue from 'link-prevue'
import 'video.js/dist/video-js.css'
import api from '@/api'
import { videoPlayer } from 'vue-video-player'
import Aplayer from 'vue-aplayer'

export default {
  components: {
    videoPlayer,
    Aplayer,
    LinkPrevue
  },
  data () {
    return {
      dialog: false,
      imagexp: false,
      snackbar: false,
      text: ''
    }
  },
  props: {
    evidencia: {},
    image: '',
    avaliavel: false,
    moreopts: true
  },
  mounted () {
    console.log('evidenc', this.evidencia)
  },
  computed: {
    permissao () {
      if (this.$store.state.user.is_superuser) {
        return true
      }
      if (this.$store.state.selectedRole.name === 'Admin') {
        return true
      }
      if (this.$store.state.selectedRole.name === 'Mediador') {
        return true
      }
      if (this.$store.state.user.username === this.evidencia.author) {
        return true
      }
      return false
    },
    showBtn () {
      if (this.$store.state.user.username !== this.evidencia.author) {
        return true
      }
    }
  },
  methods: {
    publicar (evidencia) {
      var status = 'P'
      if (evidencia.status === 'A' || evidencia.status === 'F') {
        status = 'F'
      }
      api.request('PATCH', 'evidencias/' + this.evidencia.id + '/', {
        status: status
      }).then(response => {
        this.evidencia = response.data
        this.$emit('changed', this.evidencia)
        this.text = 'Evidência foi publicada.'
        this.snackbar = true
      })
    },
    oneError () {
      alert('erro')
    },
    imageError () {
      this.onerror = null
      this.$refs.foto.src = this.evidencia.image
    },
    excluir (id) {
      let self = this
      api.request('DELETE', 'evidencias/' + id.id + '/').then(resp => {
        if (resp.status === 204) {
          self.text = 'Evidência excluída.'
          self.dialog = false
          self.snackbar = true
          self.$emit('exclui', id.id)
        }
      }).catch(() => {
        console.log('erro')
      })
    }
  }

}
</script>
<style>
.badge1{
    position: absolute;
    top: 70px;
    margin-left: -8px;
}


</style>



// WEBPACK FOOTER //
// src/components/reusable/evidencia.vue